export default "__VITE_ASSET__BRr4yJOD__"